"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _RTLPanel = _interopRequireDefault(require("../../components/RTLPanel"));
var _utils = require("../../utils");
var _constants = require("../../constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var RTLPanel = /*#__PURE__*/function (_Component) {
  _inherits(RTLPanel, _Component);
  var _super = _createSuper(RTLPanel);
  function RTLPanel(props) {
    var _this$props$channel$l;
    var _this;
    _classCallCheck(this, RTLPanel);
    _this = _super.call(this, props);
    _this.emitCurrentState = _this.emitCurrentState.bind(_assertThisInitialized(_this));
    _this.handlePanelChange = _this.handlePanelChange.bind(_assertThisInitialized(_this));
    _this.handleUpdate = _this.handleUpdate.bind(_assertThisInitialized(_this));

    // Get the direction most recently emitted before the panel was opened.
    var lastDirection = (_this$props$channel$l = _this.props.channel.last(_constants.UPDATE_EVENT_ID)) === null || _this$props$channel$l === void 0 ? void 0 : _this$props$channel$l[0].direction;
    var defaultDirection = lastDirection || (0, _utils.getDefaultTextDirection)(props.api);
    _this.state = {
      direction: defaultDirection
    };
    _this.props.channel.emit(_constants.UPDATE_EVENT_ID, {
      direction: defaultDirection,
      userInteraction: false
    });
    return _this;
  }
  _createClass(RTLPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.channel.on(_constants.INITIALIZE_EVENT_ID, this.emitCurrentState);
      // Update events can be emitted either by this component (when the toggle value changes)
      // or by the register code, which emits an event when a new story is rendered that has a parameter value.
      this.props.channel.on(_constants.UPDATE_EVENT_ID, this.handleUpdate);
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(update) {
      this.setState({
        direction: update.direction
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.channel.removeListener(_constants.INITIALIZE_EVENT_ID, this.emitCurrentState);
      this.props.channel.removeListener(_constants.UPDATE_EVENT_ID, this.handleUpdate);
    }
  }, {
    key: "emitCurrentState",
    value: function emitCurrentState() {
      this.props.channel.emit(_constants.UPDATE_EVENT_ID, this.state);
    }
  }, {
    key: "handlePanelChange",
    value: function handlePanelChange(checked) {
      this.props.channel.emit(_constants.UPDATE_EVENT_ID, {
        direction: checked ? 'rtl' : 'ltr',
        userInteraction: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var direction = this.state.direction;
      return /*#__PURE__*/_react["default"].createElement(_RTLPanel["default"], {
        checked: direction === 'rtl',
        onChange: this.handlePanelChange
      });
    }
  }]);
  return RTLPanel;
}(_react.Component);
exports["default"] = RTLPanel;
RTLPanel.propTypes = {
  api: _propTypes["default"].object.isRequired,
  channel: _propTypes["default"].object.isRequired
};